export default "/images/figma.svg?267fe03ca229496bff836f1f86f8de6e";